import { Button, RadioGroup, Switch } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardFooter, Col, Row } from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import erorSound from '../../assets/audio/alert-error.wav';
import warningSound from '../../assets/audio/alert-warning.wav';
import Breadcrumb from '../../components/common/breadcrumb';
import SorgulamaEkrani from '../../components/common/sorgulama-component/sorgulama-ekrani';
import { printLabel } from '../../utils/LabelService';
import { getApiUri, getProcessId, shouldShowRevert } from '../../utils/revertConfig';
import useFormatMessage from '../../utils/useFormatMessage';
import HasarBildirimiAddModal from '../hasar-bildirimi/components/HasarBildirimiAddModal';
import SorgulamaEkraniV3 from '../../components/common/sorgulama-component/sorgulama-ekraniV3';

const PDIComponentV3 = ({ title, radioItems, defaultRadio, showSwitch, api, modalArea, minCharacter, depo, role_name, revert_uri }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useFormatMessage();
    const [dataSource, setDataSource] = useState(null);
    const [selectedAction, setSelectedAction] = useState(defaultRadio);
    const [lastEntry, setLastEntry] = useState(null);

    // Filter radio items based on revert configuration
    const filteredRadioItems = radioItems.filter(item => {
        if (item === "Geri Al") {
            return shouldShowRevert(revert_uri);
        }
        return true;
    });

    // Switch state sadece PDI Çıkış için
    const [printEnabled, setPrintEnabled] = useState(true);
    const isPDIExit = title === "PDI Çıkış";

    // API endpoint'i seçilen işleme göre belirle
    const getApiEndpoint = () => {
        if (selectedAction === "Geri Al") {
            const apiUri = getApiUri(revert_uri);
            return apiUri || api;
        }
        return api;
    };

    const notify = (message) => toast.error(`${message}`);
    const notifySuccess = (message) => {
        toast.success(message, {
            autoClose: 1000,
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true
        });
    };

    useEffect(() => {
        if (!dataSource) return;

        const handleResponse = async () => {
            // Hata durumu
            if (dataSource?.success === false) {
                if (navigator.vibrate) {
                    navigator.vibrate(500);
                }
                const errorSound = document.getElementById("errorSound");
                errorSound.play();

                let error = dataSource?.message ? t(dataSource?.message) : t(dataSource?.error) ? t(dataSource?.error) : t("Bir hata oluştu!");
                let adres = dataSource.data ? dataSource.data.ZoneName + " " + dataSource.data.AddressCode : null;

                Swal.fire({
                    icon: 'error',
                    title: 'Hata',
                    html: `<div style="font-size: 24px;">${error.replaceAll("chassis", "Şase").replaceAll("is in an inactive groupage", "aktif bir grupajda değil.")}</div>
                    ${adres ? ` <br/><div style="margin-top: 15px;"><strong>${adres}</strong></div>` : ''}`,
                    showConfirmButton: true,
                    confirmButtonText: 'Tamam',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    background: '#fff5f5',
                    customClass: {
                        popup: 'swal2-popup-large'
                    }
                });
            }
            // Uyarı durumu
            else if (dataSource?.warning) {
                const warningSound = document.getElementById("warningSound");
                warningSound.play();

                await Swal.fire({
                    title: '⚠️',
                    html: `<div style="font-size: 24px;">
                        <div style="color: red !important; font-weight: 700; font-size: 2.5rem; padding: 10px; background: #ffdb9a; margin-top: 10px; border-radius: 10px;">${dataSource.warning.info}</div>
                        <div style="color:green; font-weight:700; margin-top: 10px;">
                            <span>✔</span> İşlem başarılı!
                        </div>
                        ${dataSource.address ? `
                            <div style="margin-top: 15px; color: #28a745;">
                                ${dataSource.address.address_code}
                            </div>
                        ` : ''}
                    </div>`,
                    showConfirmButton: true,
                    confirmButtonText: 'Tamam',
                    confirmButtonColor: '#ffc107',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    customClass: {
                        popup: 'swal2-popup-large'
                    }
                });
                // PDI Çıkış ise ve başarılı ise etiket yazdır
                if (isPDIExit && printEnabled) {
                    const chassisInput = document.getElementById("Entity_Sase");
                    if (chassisInput && chassisInput.value) {
                        await new Promise(resolve => setTimeout(resolve, 400));
                        await printLabel(chassisInput.value);
                    }
                }
            }
            // Başarılı durumu
            else if (dataSource?.success === true) {
                // --- Geri Al işlemi için Son İşlem kutusu ve Swal ---
                if (selectedAction === "Geri Al") {
                    const chassisInput = document.getElementById("Entity_Sase");
                    const chassisNo = chassisInput ? chassisInput.value : '';
                    const location = dataSource.data || t('Konum bilgisi bulunamadı');

                    setLastEntry({
                        chassis: chassisNo,
                        location: location,
                        type: 'revert'
                    });

                    await Swal.fire({
                        icon: 'success',
                        title: t('İşlem Başarılı'),
                        html: `<div style="font-size: 24px;">
                            <div>${t(dataSource.message || 'İşlem başarıyla tamamlandı')}</div>
                            <div style="margin-top: 10px;">
                                <div><strong>${t('Şase')}: </strong>${chassisNo}</div>
                                <div><strong>${t('Konum')}: </strong>${location}</div>
                            </div>
                        </div>`,
                        timer: 3000,
                        showConfirmButton: false,
                        position: 'center',
                        allowOutsideClick: false,
                        customClass: {
                            popup: 'swal2-popup-large'
                        }
                    });

                    // input temizle
                    if (chassisInput) {
                        chassisInput.value = '';
                        chassisInput.focus();
                    }
                    return;
                }
                if (dataSource.message === "PDI data successfully removed") {
                    let adress = dataSource.data
                    let sase = dataSource.sase

                    setLastEntry({
                        chassis: sase,
                        location: adress,
                        type: selectedAction === "Geri Al" ? 'revert' : 'entry'
                    });

                    await Swal.fire({
                        icon: 'success',
                        title: t('İşlem Başarılı'),
                        html: `<div style="font-size: 24px;">
                            <div>${t(dataSource.data || 'İşlem başarıyla tamamlandı')}</div>

                        </div>`,
                        timer: 3000,
                        showConfirmButton: false,
                        position: 'center',
                        allowOutsideClick: false,
                        customClass: {
                            popup: 'swal2-popup-large'
                        }
                    });
                }
                // --- Normal işlemler ---
                else if (dataSource.address || dataSource?.data) {
                    let adress = typeof dataSource.address === 'string' ? dataSource.address :
                        dataSource.address?.address_code ? dataSource.address.address_code :
                            (dataSource.data ? `${dataSource.data.ZoneName} ${dataSource.data.AddressCode}` : '');
                    let groupNo = dataSource.data?.GroupageNo;

                    setLastEntry({
                        chassis: dataSource.chassis_no,
                        location: adress,
                        type: selectedAction === "Geri Al" ? 'revert' : 'entry'
                    });

                    await Swal.fire({
                        icon: 'success',
                        html: `<div style="font-size: 24px;">
                            <b>${adress}</b>
                            ${groupNo ? `<br/><span style="font-size: 20px;">Grupaj No: ${groupNo}</span>` : ''}
                        </div>`,
                        timer: 3000,
                        showConfirmButton: false,
                        position: 'center',
                        allowOutsideClick: false,
                        customClass: {
                            popup: 'swal2-popup-large'
                        }
                    });
                    // PDI Çıkış ise ve başarılı ise etiket yazdır
                    if (isPDIExit && printEnabled) {
                        const chassisInput = document.getElementById("Entity_Sase");
                        if (chassisInput && chassisInput.value) {
                            await new Promise(resolve => setTimeout(resolve, 500));
                            await printLabel(chassisInput.value);
                        }
                    }

                    const input = document.querySelector('input[type="text"]');
                    if (input) {
                        input.value = '';
                        input.focus();
                    }
                } else {
                    notifySuccess("Başarılı");
                }
            }
        };

        handleResponse();
    }, [dataSource]);

    return (
        <div>
            <audio id="errorSound" src={erorSound} preload="auto"></audio>
            <audio id="warningSound" src={warningSound} preload="auto"></audio>
            <Breadcrumb current={t(title)} depo={depo} />
            <Card>
                <Row className='m-3'>
                    <Col md="12">
                        <RadioGroup
                            id='HasarBildir'
                            items={filteredRadioItems}
                            defaultValue={defaultRadio}
                            stylingMode='outlined'
                            layout='horizontal'
                            itemRender={(data) => (
                                <div>
                                    <span>{t(data)}</span>
                                </div>
                            )}
                            onValueChange={(e) => {
                                setSelectedAction(e);
                                if (e === "Hasar Bildir") {
                                    document.querySelector('.hasar-bildirimi').style.display = "block";
                                } else {
                                    document.querySelector('.hasar-bildirimi').style.display = "none";
                                }
                            }}
                        />
                    </Col>
                </Row>
                {/* Switch sadece PDI Çıkış için gösterilir */}
                {isPDIExit && showSwitch && (
                    <Row className='m-3'>
                        <Col md="12">
                            <span style={{ fontWeight: "600" }}>{t("Etiket Yazdır")}&emsp;</span>
                            <Switch
                                width={100}
                                defaultValue={true}
                                onValueChanged={(e) => setPrintEnabled(e.value)}
                            />
                        </Col>
                    </Row>
                )}
                <SorgulamaEkraniV3
                    apiEndpoint={getApiEndpoint()}
                    setData={setDataSource}
                    minCharacter={minCharacter}
                    role_name={role_name}
                    title={title}
                    revert_uri={revert_uri}
                    isRevertMode={selectedAction === "Geri Al"}
                    process_id={getProcessId(revert_uri)}
                />
                <CardFooter className="p-1" style={{
                    textAlign: "right",
                    color: "red",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: "1.5rem"
                }}>
                    <Button onClick={() => {
                        if (document.getElementById("Entity_Sase").value.length < 17) {
                            notify(t("17 karakterli şase numarası giriniz"))
                        }
                        else setIsOpen(!isOpen)
                    }} className='hasar-bildirimi' style={{ display: "none", width: "max-content", padding: "5px", color: "white", background: "#ff4040" }}>
                        <i>
                            {t("Hasar Bildir")}
                        </i>
                    </Button>

                    {lastEntry && (
                        <div className="mt-4 w-100" style={{ minWidth: 220, maxWidth: 350 }}>
                            <div className="p-3 border rounded bg-light text-start" style={{ textAlign: 'left' }}>
                                <h6 className="mb-2 text-dark" style={{ textAlign: 'left' }}> --- Son İşlem</h6>
                                <div className="mb-1 text-dark" style={{ textAlign: 'left' }}>
                                    <span className="font-weight-bold">Şase:</span> {lastEntry.chassis}
                                </div>
                                <div className="text-dark" style={{ textAlign: 'left' }}>
                                    <span className="font-weight-bold">Konum:</span> {lastEntry.location}
                                </div>
                            </div>
                        </div>
                    )}
                </CardFooter>
            </Card>
            <HasarBildirimiAddModal isOpen={isOpen} setIsOpen={setIsOpen} area={modalArea} />

            <style>
                {`
                    .swal2-popup-large {
                        width: 600px !important;
                    }
                    .swal2-title {
                        font-size: 28px !important;
                    }
                    .swal2-html-container {
                        font-size: 24px !important;
                        margin: 1em 0 !important;
                    }
                `}
            </style>
        </div>
    );
};

export default PDIComponentV3;